var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderCurve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 386,
    viewBox: "0 0 1728 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1060.9 35.41C1434.06 -47.2865 1711.27 34.8796 1873.99 79.427C1879.04 80.8105 1881.35 86.5714 1878.75 91.1164L1837.02 163.865C1835.62 166.315 1833.02 167.843 1830.2 167.884L2.7704 194.394C-1.07895 194.45 -4.42218 191.756 -5.18643 187.983L-33.9184 46.1305C-34.9932 40.8245 -30.404 36.0264 -25.0217 36.6091C551.803 99.0593 721.704 110.579 1060.9 35.41Z",
    fill: "#211452"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M784.879 349.911C408.48 433.199 129.686 349.045 -32.4993 304.833C-35.984 303.883 -38.3203 300.743 -38.3203 297.131V181.61C-38.3203 177.205 -34.7596 173.629 -30.355 173.61L1895.97 165.277C1901.74 165.252 1905.64 171.164 1903.35 176.46L1841.15 319.858C1839.76 323.072 1836.31 324.991 1832.82 324.615C1252.06 261.93 1125.15 274.619 784.879 349.911Z",
    fill: "#211452"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCurve);
export default __webpack_public_path__ + "static/media/headerCurve.4c3033560f7a7021e48795fc53fa315e.svg";
export { ForwardRef as ReactComponent };